import {
  BASE_LAYERS,
  PLANTING,
  PLANTING_IDS,
  PLANTING_HYBRID_DEFAULT,
} from '../../constants/mapLayerIds';
import { UNKOWN_PRODUCT_TYPE } from '../../constants/cropCodes';

/**
 * Extracts planting layers using seasonObject for a particular season
 * @param {Object} seasonObject
 * @param {String} season
 * @param {Object} crops
 * @return {Object}
 */
export function extractPlantingLayers(seasonObject, season, crops) {

  if (seasonObject.plantingYear) {
    return PLANTING_IDS.reduce(
      (result, id) => {
        if (id === PLANTING.PLANTING_SCRIPT) {
          return result;
        }
        if (id === PLANTING.HYBRID) {
          const [, cropId] = season.split(':');
          const productType = crops[cropId] && crops[cropId]['product-type'];

          const nameId = (productType && productType !== UNKOWN_PRODUCT_TYPE) ? productType : PLANTING_HYBRID_DEFAULT;

          return { ...result, [id]: { nameId } };
        }
        return { ...result, [id]: {} };
      },
      { [BASE_LAYERS.PLANTER_ELEVATION]: {} }
    );
  }
  return {};
}
